/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

export class EnumObj {
  public Id?: number;
  public Name?: string;

  constructor(init?: Partial<EnumObj>) {
    Object.assign(this, init);
  }
}


export class Constants {
  public static readonly PROFILE_SELECT_MODAL = 'profile-select-modal';
  public static readonly ERROR_DEFAULT = -1;
  public static readonly ERROR_DEFAULT_MESSAGE = "Si è verificato un errore nell'operazione";
  public static readonly PAGE_SIZE = 20;
  public static readonly SHORT_PAGE_SIZE = 10;

  public static readonly ERROR_AUTH_REQUIRES_VERIFICATION = 'REQUIRES_VERIFICATION';
  public static readonly ERROR_AUTH_INVALID_CREDENTIALS = 'invalid_grant';
}

export class BasicItem {
    public id;
    public description;
    public code?: string;

    constructor(id?: number, description?: string, code?: string) {
      this.id = id ?? 0;
      this.description = description ?? '';
      this.code = code;
    }
}

export class SharedEnumModelKeyValue {
  public Key : number = 0;
  public Value : string = '';
}

